import { parseQueryStrings } from './urlParamUtils';
import GeocoderService from '../services/geocoderService';

/**
 * There are requirements on when to call the Geo Api besides
 * the configuration. This Parses the URL and validates it's
 * parameters. Checking for location and a geo flag in the url.
 * @param {Object} config
 * @param {Object} values
 * @param {Object} hash
 * @returns {Boolean}
 */
export function isAllowedToCallGeoApi(config, values, hash) {
  const queryStringValues = parseQueryStrings(values, hash);

  if (
    queryStringValues.address ||
    (queryStringValues.lat && queryStringValues.long)
  ) {
    return false;
  } else if (queryStringValues.geo === 'true' || config.ipdata_key_active) {
    return true;
  }
}

export function isNotAllowedToCallGeoApi(values, hash) {
  const queryStringValues = parseQueryStrings(values, hash);
  return queryStringValues.geo === 'false';
}

export function getUserLocationByAddress(address) {
  return new Promise((resolve, reject) => {
    const geocoderService = new GeocoderService();
    geocoderService
      .geocodeByAddress(address)
      .then(results => resolve(results))
      .catch(error => reject(error));
  });
}

export function getBaiduUserLocationByAddress(address) {
  return new Promise((resolve, reject) => {
    const geocoderService = new GeocoderService();
    geocoderService
      .baiduGeocodeByAddress(address)
      .then(results => resolve(results))
      .catch(error => reject(error));
  });
}

export function getYandexUserLocationByAddress(address) {
  return new Promise((resolve, reject) => {
    const geocoderService = new GeocoderService();
    geocoderService
      .yandexGeocodeByAddress(address)
      .then(results => {
        console.log('results', results);
        resolve(results)
      })
      .catch(error => reject(error));
  });
}

export function getUserAddressByCoords(coords) {
  return new Promise((resolve, reject) => {
    const geocoderService = new GeocoderService();
    geocoderService
      .geocodeByCoords(coords)
      .then(results => resolve(results))
      .catch(error => reject(error));
  });
}

export function getBaiduUserAddressByCoords(coords) {
  return new Promise((resolve, reject) => {
    const geocoderService = new GeocoderService();
    geocoderService
      .baiduGeocodeByCoords(coords)
      .then(({ result }) => resolve(result))
      .catch(error => reject(error));
  });
}

// WIP!!!
export function getYandexUserAddressByCoords(coords) {
  return new Promise((resolve, reject) => {
    const geocoderService = new GeocoderService();
    geocoderService
      .yandexGeocodeByCoords(coords)
      .then(({ GeoObjectCollection }) => resolve(GeoObjectCollection))
      .catch(error => reject(error));
  });
}

/**
 *
 * @returns
 */
export function getUserLocationByIp() {
  return new Promise((resolve, reject) => {
    const geocoderService = new GeocoderService();
    geocoderService
      .geocodeByIp()
      .then(result => resolve(result))
      .catch(error => reject(error));
  });
}

/**
 *
 * @param {*} options
 * @returns
 */
export function getUserLocation(options) {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      result => resolve(result?.coords),
      error => reject(error),
      options
    );
  });
}
